export enum CountryName {
  Malaysia = 'Malaysia',
  Philippines = 'Philippines',
}

export enum CountryUrl {
  Malaysia = 'my',
  Philippines = 'ph',
}

export enum CountryCode {
  Malaysia = 'MYS',
  Philippines = 'PHL',
}
